import AppState from '../state'

// export const HARDCODED_LABEL = '67b66367-4d72-4add-ad24-a696286019f1'; // BeatBread
// export const HARDCODED_LABEL = '20310ed7-abad-4ca8-94f4-6fe5c3805be2';  // Flood
// export const HARDCODED_LABEL = '7e2e0a1e-c931-465b-a478-ffa52274845f';  // WVE Label
// export const HARDCODED_LABEL = 'd724fa7c-6e15-4383-99a3-09e9435b012e';  // WVE Distro

export const selectDeals = (state: AppState) => state.deals.owned.filter((l) => l.ownerId === state.recordLabels.active?.id);
// export const selectDeals = (state: AppState) => state.deals.owned.filter((l) => l.ownerId === HARDCODED_LABEL);

export const selectLabelDeals = (state: AppState) => selectDeals(state).filter((l) => l.type === 'label-agreement');

export const selectAdvanceDeals = (state: AppState) => selectDeals(state).filter((l) => l.type === 'exclusive-license-with-advance');